
import { defineComponent } from "vue";
import Grid from "@moonlight/vue3/components/Grid.vue";
import Button from "@moonlight/vue3/components/Button.vue";
import { trans } from "@/globals/translator";
import { useHead } from "@vueuse/head";

export default defineComponent({
  components: {
    Grid,
    Button,
  },
  setup() {
    useHead({
      title: trans("general.are_you_lost") as string,
      meta: [
        {
          name: `description`,
          content: trans("general.it_happens_to_all"),
        },
      ],
    });
    return {
      trans,
    };
  },
});
